<!-- Responsibility: Implement scene world sidebar behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->
<scene-world-sidebar>
  <aside class="stats-sidebar { props.isOpen ? 'open' : '' }" data-open={ props.isOpen ? 'true' : 'false' }>
    <header>
      <button aria-label="Close world panel" onclick={ props.closeStats }>✕</button>
      <nav aria-label="World panel sections">
        <button class={ props.activeTab === 'journal' ? 'active' : '' } onclick={ () => props.switchTab?.('journal') }>Quests</button>
        <button class={ props.activeTab === 'atlas' ? 'active' : '' } onclick={ () => props.switchTab?.('atlas') }>Atlas</button>
      </nav>
    </header>
    <div class="panel">
      <journal-panel if={ props.activeTab === 'journal' }></journal-panel>
      <atlas-panel if={ props.activeTab === 'atlas' }></atlas-panel>
    </div>
  </aside>

  <script>
    import AtlasPanel from '../panels/atlas-panel.riot'
    import JournalPanel from '../panels/journal-panel.riot'

    export default {
      components: { AtlasPanel, JournalPanel },
    }
  </script>
</scene-world-sidebar>
